import { ComponentType } from 'react'

import { DataCollectionCategories } from 'modules/processes/domain'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import ContractDataPreview from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/ContractData/Preview'
import RequestBankAccountPreview from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/RequestBankAccount/Preview'
import RequestEmployeeAdditionalInformationPreview from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/RequestEmployeeAdditionalInformation/Preview'
import RequestGeneralInformationContent from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/RequestGeneralInformation/Preview'
import RequestIdPreview from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/RequestId/Preview'
import SendDocumentPreview from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/SendDocument/Preview'
import SignDocumentsPreview from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/SignDocuments/Preview'
import SingleTaskPreview from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/Single/Preview'
import UploadDocumentPreview from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/UploadDocument/Preview'

export type TaskComponent = ComponentType

const SUPER_TASKS: Partial<Record<TaskConfigurationTypes, TaskComponent>> = {
  [TaskConfigurationTypes.Single]: SingleTaskPreview,
  [TaskConfigurationTypes.UploadDocument]: UploadDocumentPreview,
  [TaskConfigurationTypes.SignDocuments]: SignDocumentsPreview,
  [TaskConfigurationTypes.SendDocumentTemplate]: SendDocumentPreview,
}

const DATA_COLLECTION_SUPER_TASKS: Partial<Record<DataCollectionCategories, TaskComponent>> = {
  [DataCollectionCategories.identificationNumber]: RequestIdPreview,
  [DataCollectionCategories.bankInformation]: RequestBankAccountPreview,
  [DataCollectionCategories.generalInformation]: RequestGeneralInformationContent,
  [DataCollectionCategories.employee_questions_cf]: RequestEmployeeAdditionalInformationPreview,
  [DataCollectionCategories.contract_data]: ContractDataPreview,
}

export default Object.assign({}, SUPER_TASKS, DATA_COLLECTION_SUPER_TASKS)
